'use client';

import {useRef} from 'react';

import {EventsCard} from '@web-catalog/components/NewMainPage/parts/Events/EventsCard';

import {Scroller} from '@web-catalog/ui-kit/Scroller';

import {useLogEventsSwipe} from '@web-catalog/utils/analytics/interestingPage/useLogEventsSwipe';
import {useLogOnEventsShow} from '@web-catalog/utils/analytics/interestingPage/useLogOnEventsShow';

import {SelectionDataWithEvents} from '../../types';
import styles from './Events.module.scss';

export const Events = ({
  selection,
  title,
  displayedSelectionNumber,
  selectionId,
}: {
  selection: SelectionDataWithEvents;
  title: string;
  displayedSelectionNumber: number;
  selectionId: string;
}) => {
  const ref = useRef(null);
  useLogOnEventsShow({
    ref,
    selectionNumber: displayedSelectionNumber,
    selection: {id: selectionId, title: {value: title}},
  });

  const onSwipe = useLogEventsSwipe(
    selectionId,
    displayedSelectionNumber,
    title,
  );

  return (
    <section data-testid="events" ref={ref}>
      <h2>{title}</h2>
      <Scroller classes={{root: styles.root}} onSwipe={onSwipe}>
        {selection.events.map((elem, index) => (
          <EventsCard key={elem.id} {...elem} cardNum={index + 1} />
        ))}
      </Scroller>
    </section>
  );
};
